"use strict"
import {http} from '../../core'
import config from '../../app.config'
const RequestService = http.create()
const RequestbaseURL = http.create({baseURL:config.BASEURL})

export default {
    // 新增配置项关系
    cmdbRelationshipAdd: function(params) {
        return  RequestService.post('cmdb/relationship/add', params)
    },
    // 删除配置项关系
    cmdbRelationshipDelete: function(params) {
        return  RequestService.post('cmdb/relationship/delete', params)
    },
    nodeInfo(params) {
        return RequestbaseURL.get('appcenter/apptree/appnode/v1', params)
    },

    // 主机解绑
    serverNtying(params) {
        return RequestbaseURL.post('appcenter/apptree/app/server/ntying', params)
    },
    // 全部应用列表
    appList(params) {
        return RequestbaseURL.get('appcenter/apptree/v1/app/list', params);
    },
    // 二维码信息
    cmdbDetailSimple: function(params) {
        return  RequestService.get('cmdb/qr_code', params)
    },
    // 配置项列表
    cmdbLlist: function(params) {
        return  RequestService.get('cmdb/list', params)
    },
    // 我的配置项
    cmdbdMy: function(params) {
        return  RequestService.get('cmdb/my', params)
    },
    // 新增配置项
    cmdbAdd: function(params) {
        return  RequestService.post('cmdb/add', params)
    },
    // 编辑配置项
    cmdbEdit: function(params) {
        return RequestService.post('cmdb/edit', params)
    },
    // 删除配置项
    cmdbdDelete: function(params) {
        return  RequestService.post('cmdb/delete', params)
    },
    // 配置项详情
    cmdbDescribe: function(params) {
        return  RequestService.get('cmdb/describe', params)
    }, 
    // 按类型获取子分类
    typeList: function(params) {
        return  RequestService.get('category/type/list/all', params)
    },
    // 根据父分类id,获取所有子分类
    childrenList: function(params) {
        return  RequestService.get('category/children/list/all', params)
    },
    // 获取部门树顶级节点
    treeTop: function(params) {
        return  RequestbaseURL.get('itsm/v2/organization/department/tree/top', params)
    },
    // 获取部门树子节点
    treeChildren: function(params) {
        return  RequestbaseURL.get('itsm/v2/organization/department/tree/children', params)
    },
    // 获取公司接口
    companyList: function(params) {
        return  RequestService.get('organization/company/list', params)
    },
    // 获取部门用户
    userList: function(params) {
        return  RequestbaseURL.get('itsm/v2/organization/user/list', params)
    },
    // 知识库列表
    knowledgeQuery: function(params) {
        return  RequestService.get('knowledge/query', params)
    },
    // 拓扑图
    getVisList:function (params) {
       return RequestService.get('cmdb/topological_graph',params);
        // return Promise.resolve({
        //     "edges": [
        //         {
        //             "color": "",
        //             "from": "Cmd_20190710_0010",
        //             "label": "安装到",
        //             "to": "Cmd_20190709_0007"
        //         },
        //         {
        //             "color": "",
        //             "from": "Cmd_20190710_0010",
        //             "label": "安装到",
        //             "to": "Cmd_20190711_0015"
        //         },
        //         {
        //             "color": "",
        //             "from": "Cmd_20190711_0015",
        //             "label": "被连接",
        //             "to": "Cmd_20190710_0010"
        //         }
        //     ],
        //     "nodes": [
        //         {
        //             "id": "Cmd_20190710_0010",
        //             "image": "http://wedof-itsm.beta.autoai.com/fastdfs/v1/download?file_name=webapp.png&file_id=group1/M00/00/13/wKiQo10mos6AFP5lAAAT3D7koZg0814329",
        //             "label": "天眼项目",
        //             "x": "0",
        //             "y": "0",
        //             title:"Cmd_20190710_0010"
        //         },
        //         {
        //             "id": "Cmd_20190709_0007",
        //             "image": "http://wedof-itsm.beta.autoai.com/fastdfs/v1/download?file_name=webapp.png&file_id=group1/M00/00/13/wKiQo10mos6AFP5lAAAT3D7koZg0814329",
        //             "label": "塔式服务器",
        //             title:"Cmd_20190709_0007"
        //             // "x": "800",
        //             // "y": "500"
        //         },
        //         {
        //             "id": "Cmd_20190711_0015",
        //             "image": "http://wedof-itsm.beta.autoai.com/fastdfs/v1/download?file_name=webapp.png&file_id=group1/M00/00/13/wKiQo10mos6AFP5lAAAT3D7koZg0814329",
        //             "label": "配置项测试711",
        //             "x": "0",
        //             "y": "300",
        //             title:"Cmd_20190711_0015"
        //         }
        //     ]
        // })
    },
    // 拓扑图修改位置
    saveTopological:function (params) {
        return RequestService.post('cmdb/topological_graph/save',params);
    },
    // 拓扑图修改位置----新
    saveTopologicalNew:function (params) {
        return RequestService.post('cmdb/topology/graph/save',params);
    },
    //拓扑图-拓扑图列表
    topologyMapList: function(params) {
        return  RequestService.get('cmdb/topology/list', params)
    },
    //拓扑图-新增拓扑图
    topologyMapAdd: function(params) {
        return  RequestService.post('cmdb/topology/add', params)
    },
    //拓扑图-编辑拓扑图
    topologyMapEdit: function(params) {
        return  RequestService.post('cmdb/topology/edit', params)
    },
    //拓扑图-删除拓扑图
    topologyMapDel: function(params) {
        return  RequestService.post('cmdb/topology/delete', params)
    },
    //拓扑图-查看拓扑图
    topologyMapGraph: function(params) {
        return  RequestService.get('cmdb/topology/graph', params)
    },
    //拓扑图-拓扑图列表
    topologyRelationList: function(params) {
        return  RequestService.get('cmdb/topology/relation/list', params)
    },
    //拓扑图-拓扑关系新增
    topologyRelationAdd: function(params) {
        return  RequestService.post('cmdb/topology/relation/add', params)
    },
    //拓扑图-拓扑关系删除
    topologyRelationDel: function(params) {
        return  RequestService.post('cmdb/topology/relation/delete', params)
    },
}
